import { BellOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Button, Card, Col, Divider, Flex, Row, Typography } from 'antd'
import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import FormCard from './FormCard'

const { Title, Text } = Typography

export interface NotificationSettingItem {
  slug: string
  title: string
  recipient?: 'user' | 'admin'
  icon: ReactNode | 'mail' | 'bell'
  description: string
  enabledSettingKey?: string
  content?: ReactNode
  onTestClick?: ReactNode
}

interface NotificationSettingListProps {
  items: NotificationSettingItem[]
  title: string
}
const NotificationSettingList = ({
  items,
  title,
}: NotificationSettingListProps) => {
  const userItems = items.filter((item) => item.recipient !== 'admin')
  const adminItems = items.filter((item) => item.recipient === 'admin')

  const renderItems = (list: typeof items) =>
    list.map((item) => (
      <Col key={item.slug} span={24}>
        <Card>
          <Flex align="center" justify="space-between" gap={20}>
            <Flex align="center" gap={16} style={{ flex: 1 }}>
              <span>
                {item.icon == 'mail' ? (
                  <MailOutlined />
                ) : item.icon == 'bell' ? (
                  <BellOutlined />
                ) : (
                  item.icon
                )}
              </span>
              <Flex vertical>
                <Title level={5} className="m-0">
                  {item.title}
                </Title>
                <Text type="secondary">{item.description}</Text>
              </Flex>
            </Flex>
            <Flex
              wrap
              gap={10}
              align="center"
              justify="flex-end"
              style={{ flex: 1, maxWidth: '30%' }}
            >
              {item.enabledSettingKey && (
                <Flex>
                  <FormCard
                    saveOnChange
                    entity={Entity.setting}
                    action={SBRMAction.Update}
                    noCardWrap
                    metadata={[
                      {
                        key: MetadataKey.Setting,
                        value: item.enabledSettingKey,
                      },
                    ]}
                  />
                </Flex>
              )}

              {item.content && (
                <Link to={item.slug}>
                  <Button
                    variant="filled"
                    color="default"
                    icon={<SettingOutlined />}
                  >
                    Settings
                  </Button>
                </Link>
              )}

              {item.onTestClick}
            </Flex>
          </Flex>
        </Card>
      </Col>
    ))

  return (
    <Row gutter={[0, 16]}>
      <Col span={24}>
        <PageTitle title={title} level={4} style={{ margin: 0 }} />
      </Col>
      <Divider style={{ marginBottom: 10, marginTop: 5 }} />
      {userItems.length > 0 && (
        <Col span={24}>
          <Text type="secondary">User notifications</Text>
        </Col>
      )}
      {renderItems(userItems)}

      {adminItems.length > 0 && (
        <Col span={24}>
          <Divider />
          <Text type="secondary">Administrator notifications</Text>
        </Col>
      )}

      {renderItems(adminItems)}
    </Row>
  )
}

export default NotificationSettingList
